import { useSuspenseApiGetPolicy } from '@repo/api-codegen';
import { useParams } from 'react-router';
import { useListPolicyRules } from '../../api/hooks/policy';
import PoliciesCreatePage from './PoliciesCreatePage';

export default function PoliciesEditPage() {
	const { id } = useParams();

	const { data: policy } = useSuspenseApiGetPolicy({
		pathParams: { policyId: id! },
	});

	const { data: policyRules } = useListPolicyRules(
		{ pathParams: { policyId: id! } },
		{ enabled: !!id }
	);

	return (
		<PoliciesCreatePage
			policy={policy}
			policyRules={policyRules?.results || []}
		/>
	);
}
